<template>
    <div id="contatti" class="section contatti" v-if="this.dataLoaded">
        <div class="big-title">
            <h1>{{labelTitlePage}}</h1>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-lg-6">
                    <h3>{{labelTitle}}</h3>
                    <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title" data-aos-delay="4000">{{labelTitlePage}}</h1>
                     <div class="sedi">
                        <SediContatti :dataSedi="this.dataSedi" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SediContatti from './SediContatti.vue';

export default {
  name: 'section-attivita',
    components:{
      SediContatti
  },
  props: {
      dataPages: {
          type: String
      },
      dataSedi: {
          type: String
      }
  },
    computed:{
            labelTitle(){
                let label;
                if(this.$route.params.lang == "it"){
                    label = "Contatti"
                } else {
                    label = "Contact Us"
                }
                return label
            },
            labelButton(){
                let label;
                if(this.$route.params.lang == "it"){
                    label = "Invia"
                } else {
                    label = "Send"
                }
                return label
            },
            labelTitlePage(){
                let label;
                if(this.$route.params.lang == "it"){
                    label = "Contatti"
                } else {
                    label = "Contacts"
                }
                return label
            },
        },
  data:()=>{
        return {
            formAction:"https://ptnlex-api-prod.interfase.tv/contact-form",
            titlePage:"Contatti",
            idIntroPage:"4f5d56da-0d43-4098-bfc2-696010d632c7",
            page:[],
            dataLoaded:false,
            currentLang:"",
            name: '',
            email: '',
            message: '',
            phone: '',
            agree: false,
            risposta: ''
        }
  },
methods:{
    checkForm: function (e) {
            let formdata = new FormData();
            formdata.append('name', this.name);
            formdata.append('email', this.email);
            formdata.append('message', this.message);
            formdata.append('phone', this.phone);

            let requestOptions = {
                method: 'POST',
                body: formdata,
                redirect: 'follow'
            };
            fetch(`https://ptnlex-api-prod.interfase.tv/contact-form`, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((json) => {
                console.log("json.esito",json.esito)
                if (json.esito && this.currentLang=="it") {
                    this.risposta = 'Messaggio inviato, grazie.'
                    this.name = this.email = this.message = this.phone = ''
                } else if(this.currentLang=="it"){
                    this.risposta = 'Qualcosa non va, ricontrolla i campi o contatta l\'amministratore'
                }

                if (json.esito && this.currentLang=="en") {
                    this.risposta = 'Message sent, thank you.'
                    this.name = this.email = this.message = this.phone = ''
                } else if(this.currentLang=="en"){
                    this.risposta = 'Something went wrong.'
                }
            })
            e.preventDefault();
        },
    goToPrivacy(){
      this.$router.push({ name: 'privacy'})
    },
    splittedTitle: function (value) {
        return value.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>\n`);
    },
    findObjectbyKey(array, key, value){
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return null;
    }
},
    mounted(){
        this.currentLang = this.$route.params.lang;
        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.page = this.findObjectbyKey(json.data,"id",this.idIntroPage)
            this.dataLoaded = true
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
.response {
    color: #fff;
    padding: 17px 6px 6px 6px;
    color: #333 !important;
    text-align: center;
    margin-top: 10px;
    position: relative;
    width: 100%;
    font-weight: 600;
    text-transform: uppercase;
    font-family: "Playfair display" !important;
}
.contatti {
    height: auto;
    background: #E3E3E3 url("../assets/map-contatti.png") 50% 41% no-repeat;
    background-size: cover;
    .form {
        background: #fff;
        padding:3rem 4rem ;
        button {
            width: 100%;
            display: block;
            border: 1px solid #728FC2;
            background: transparent;
            padding: 15px 10px;
            font-family: "Lato";
            color: #728FC2;
            text-transform: uppercase;
        }
        h1 {
            font-size: 0.875rem;
            font-family: "Lato";
            line-height: 1.5rem;
            font-weight: 600;
        }
        p {
            font-size: 0.8125rem;
            color: #666666;
            font-family: "Lato";
            line-height: 1.3rem;
        }
    }
    .sede-container {
        h1 {
            font-size: 2.3rem;
            color: #14182E;
            line-height: 2.5rem;
            margin-bottom: 2.5rem;

        }
        p {
            font-size: 0.875rem;
            color: #14182E;
            line-height: 0.5rem;
        }
    }
}
form {
    label {
        display: none;
    }
    input {
        font-size: 0.875rem;
        width: 100%;
        padding: 10px 10px;
        margin-bottom: 2rem;
        border-width: 0px 0px 1px 0px;
        border-color: rgb(216, 216, 216);
    }
    textarea{
        font-size: 0.875rem;
        width: 100%;
        padding: 10px 10px;
        margin-bottom: 2rem;
        border-width: 0px 0px 1px 0px;
        border-color: rgb(216, 216, 216);
        min-height: 70px;
    }
    .checkbox-container {
        padding: 10px 10px 10px 20px;
        display: flex;
        flex-direction: row;
        label {
            display: block;
            font-size: 0.875rem;
            font-family: "Lato";
            line-height: 1.5rem;
            font-weight: 600;
         }
         input {
             width:auto ;
         }
    }
}
@media (max-width: 992px){
    .contatti {
        overflow: hidden;
        background: #E3E3E3 url("../assets/map-contatti-mobile.png") 50% 41% no-repeat;

        background-size: 160%;
        background-position: 0% -8%;
    }
    .contatti .form {
        position: relative;
        form {
            position: relative;
            z-index: 1;
        }
        &::before{
            content: "";
            position: absolute;
            top: 0;
            left: -50%;
            right: 0;
            width: 200%;
            height: 100%;
            background-color: #fff;
            z-index: 0;
        }
    }
}
@media (max-width: 768px){
        .contatti {
        background-size: 164%;
    background-position: 0% 0%;
    }
    .contatti .form {
        background: #fff;
        padding: 2rem 15px;
    }
}
</style>
